<template>
<div class="singleKpiRecord">
  <section class="orderDetails">

    <b-row>
      <b-col cols="4">
        <h3>Order Id: <div  class="orderNo"><span>{{storePrefix}}{{ orderRecord.order_no }}</span></div>
       
        
        </h3>
      </b-col>
      <b-col cols="4">
        <strong>Designer assigned:</strong> {{ designerName }}
      </b-col>
      <b-col>
        <div class="clearfix">
          <b-badge variant="danger" class="cancelledStatus" v-if="isCancelled">Cancelled</b-badge>
        </div>
      </b-col>
    </b-row>

    <ul class="kpiGraph">
      <li class="onNeutral" :class="{onTime: newOrderToSentDraftDiff && newOrderToSentDraftDiff <= 24 , delayTime: newOrderToSentDraftDiff && newOrderToSentDraftDiff > 24}">
        <div class="stepName">
          New Order 
          
          <span>{{ moment(orderRecord.created_in_shopify).utc().format('DD-MM-YYYY, h:mm a') }}</span>
          
        </div>
        <i class="arrow right"></i>
    
        
        <div class="timeStatus" v-if="newOrderToSentDraftDiff">
           {{ newOrderToSentDraftDiff > 24 ? "Delayed by :" : "Time taken :" }} {{ newOrderToSentDraftDiff > 24 ? 24 - newOrderToSentDraftDiff  :  (newOrderToSentDraftDiff <= 24) ? newOrderToSentDraftDiff : 0 }} hrs
           
        </div>
        <kpi-drop-icon :done="orderRecord.createdAt ? true : false" icon-class="fa-cubes"/>
      </li>
      <li class="onNeutral" :class="{onTime: printSendingStatus.sent && printSendingStatus.diff <= 48 , delayTime: printSendingStatus.sent && printSendingStatus.diff > 48}">
        <div class="stepName">
          Draft Sent
          
          <span>{{ draftStatus.sent ? moment(draftStatus.createdAt).utc().format('DD-MM-YYYY, h:mm a') : '--'}}</span>
          
        </div>
        <i class="arrow right"></i>
        
        <div class="timeStatus" v-if="printSendingStatus.sent">
           {{   printSendingStatus.diff > 48 ? 'Delayed by' : printSendingStatus.diff <= 48 ? 'Time taken' : '--'}}: {{ printSendingStatus.sent ? 48 - printSendingStatus.diff  : '--'}} hrs
        </div>
        <kpi-drop-icon :done="draftStatus.sent ? true : false" icon-class="fa-picture-o"/>

      </li>
      <li class="onNeutral"  :class="{onTime: shippingStatus.created && shippingStatus.diff <= 24 , delayTime: shippingStatus.created && shippingStatus.diff > 24}">
        <div class="stepName">Sent for Print
          
          <span>{{ orderRecord.sentForPrintAt ? moment(orderRecord.sentForPrintAt).utc().format('DD-MM-YYYY, h:mm a') : '--' }}</span>
          
        </div>
        <i class="arrow right"></i>
        <div class="timeStatus" v-if="shippingStatus.created">
           {{   shippingStatus.diff > 24 ? 'Delayed by' : shippingStatus.diff <= 24 ? 'Time taken' : '--'}}: {{ shippingStatus.created ? 24 - shippingStatus.diff  : '--'}} hrs
        </div>
        <kpi-drop-icon :done="orderRecord.sentForPrintAt ? true : false" icon-class="fa-print"/>
      </li>
      <li class="onNeutral">
        <div class="stepName">
          Shipping ID generated
          <span>
             {{ orderRecord.OrderShippings.length > 0 ? moment(orderRecord.OrderShippings[0].createdAt).utc().format('DD-MM-YYYY, h:mm a') : '--'}}
             
          </span>
          <span>
            {{ orderRecord.OrderShippings.length > 0 ? orderRecord.OrderShippings[0].shippingId : '' }}
          </span>
          </div>
        <i class="arrow right"></i>
        <div class="completedTag">
          Completed
        </div>
        <kpi-drop-icon :done="orderRecord.OrderShippings.length > 0 ? true : false" icon-class="fa-truck"/>
        <kpi-drop-icon :done="false" :is-last="true" icon-class="fa-thumbs-up"/>
      </li>
    </ul>

    <ul class="expectedTimes">
       <li>Time Limit: 24 Hours</li>
       <li>Time Limit: 48 Hours</li>
       <li>Time Limit: 24 Hours</li>
    </ul>

    <a href="" @click.prevent="showItems = !showItems" class="orderItemsTrigger">Show order info ({{ orderRecord.ShopifyOrderItems.length }} items)</a>
    <div class="orderItems m-t-20" v-if="showItems">
       <div :key="item.id" v-for="item in orderRecord.ShopifyOrderItems">
          <p><strong>Item name (Qty: {{ item.quantity }}) :</strong> {{ item.name }} </p>
       </div>
       <div class="m-b-15">
         <strong>Order Tags :</strong> {{ orderRecord.tags }} 
       </div>
       <div class="">Shopify ID: {{ orderRecord.shopify_id }}</div>
    </div>

    
  </section>
</div>
</template>

<script>
const KpiDropIcon = () => import(/* webpackChunkName: "kpi.drop-icon" */ './kpi-drop-icon')
import moment from 'moment';
export default {
  data(){
    return {
      showItems: false
    }
  },
  components: {KpiDropIcon},
  props: {
    orderRecord: {
      type: Object,
      default: () => ({})
    },
    storePrefix: {
      type: String,
      default: ''
    }
  },
  methods: {
     dateTimeDiff(dateTimeOne, dateTimeTwo){
        let a = moment(dateTimeOne);
        let b = moment(dateTimeTwo)
        return a.diff(b, 'hours');
     }
  },
  computed: {
     designerName(){
       let designerName = "Unknown"
       let tagsArray = this.orderRecord.tags ? this.orderRecord.tags.split(',') : []
       tagsArray.forEach(tag => {
          if(tag.includes('-designer')){
              designerName = tag.replace('-designer','');
          }
       })
       return designerName;
     },
     draftStatus(){
    
        let draftRecord = this.orderRecord.CustomerDrafts.length > 0 ? {
           createdAt: this.orderRecord.CustomerDrafts[0].createdAt,
           sent: true,
        } : {sent: false}

        return draftRecord;
     },
     newOrderToSentDraftDiff(){
        if(this.draftStatus.sent && this.orderRecord.created_in_shopify){
          return this.dateTimeDiff(this.draftStatus.createdAt, this.orderRecord.created_in_shopify)
        } 
     },
     printSendingStatus(){
       if(this.orderRecord.sentForPrintAt && this.draftStatus.sent){
          return {
            sent: true,
            diff: this.dateTimeDiff(this.orderRecord.sentForPrintAt, this.draftStatus.createdAt)
          }
       }
       else{
         return {
           sent: false,
           diff: null
         }
       }
     },
     shippingStatus(){
       if(this.orderRecord.sentForPrintAt && this.orderRecord.OrderShippings.length > 0){
          return {
            created: true,
            diff: this.dateTimeDiff(this.orderRecord.OrderShippings[0].createdAt, this.orderRecord.sentForPrintAt)
          }
       }else{
         return {
           created: false,
           diff: null
         }
       }
     },
     isCancelled(){
       if(this.orderRecord.tags && this.orderRecord.tags.toLowerCase().includes('cancel')){
          return true;
       }
       return false;
     }
  }
}
</script>

<style lang="scss" scoped>
$beadColor: rgb(96, 106, 124);
$delayColor: rgb(236, 73, 73);
$onTimeColor: rgb(73, 236, 154);
$onNeutral: rgb(83, 83, 83);

.singleKpiRecord {
  border: 2px solid rgb(230, 230, 230);
  padding: 25px;
  border-radius: 5px;
  padding-bottom: 30px;
  margin-bottom: 20px;
  background-color: #fff;
}

.orderNo {
  display: inline-block;
  position: relative;
  top: -5px;
  font-size: 18px;
  padding: 2px;
  
  color: #fff;
  border-radius: 3px;
  border: 1px solid rgb(47, 58, 88);
  span{
    background-color: rgb(47, 58, 88);
    display: inline-block;
    padding: 5px 10px;
  }
  
}

.kpiGraph {
  display: flex;
  padding-left: 0;
  list-style-type: none;
  margin: 80px 50px 10px 50px;

  & li:last-child::before {
    position: absolute;
    content: "";
    right: -15px;
    width: 10px;
    top: -3px;
    height: 10px;
    background-color: $beadColor;
    border-radius: 50%;
  }

  li {
    flex-grow: 1;
   
    position: relative;
    height: 3px;
    margin: 0 10px;
    transition: all 300ms ease;
    cursor: pointer;

    &::after {
      position: absolute;
      content: "";
      left: -15px;
      width: 10px;
      top: -3px;
      height: 10px;
      background-color: $beadColor;
      border-radius: 50%;
    }

    .arrow {
      border-width: 0 3px 3px 0;
      display: inline-block;
      padding: 3px;
      right:0;
      position: absolute;
      top: -3px;
      &.right {
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
      }

    }
    &.onNeutral{
       background-color: $onNeutral;
       .arrow{
         border: solid $onNeutral;
         border-width: 0 3px 3px 0;
       }
    }
    &.onTime{
       background-color: $onTimeColor;
       .arrow{
         border: solid $onTimeColor;
         border-width: 0 3px 3px 0;
       }
    }
    &.delayTime{
      background-color: $delayColor;

      .arrow{
         border: solid $delayColor;
         border-width: 0 3px 3px 0;
       }
    }
  }

  div.stepName {
    position: absolute;
    display: inline-block;
    transform: translate(-50%, 0);
    top: 20px;
    font-size: 13px;
    text-align: center;
    font-weight: 600;
    span{
      display: block;
      color: rgb(145, 145, 145);
      font-weight: normal;
    }
  }

  .completedTag {

    position: absolute;
    display: inline-block;
    transform: translate(-50%, 0);
    top: 20px;
    font-size: 13px;
    right: -50%;
    font-weight: bold;
  }


}


.timeStatus{
   position: absolute;
   top: -20px;
   font-size: 12px;
   left: 60%;
   transform: translate(-50%, 0);
   display: inline-block;
   width: 100%;
}
.expectedTimes{
  margin-top: 100px;
  list-style-type: none;
  display: flex;
  margin-left: 0;
  padding: 0 50px;
  li{
    background-color: rgb(230, 230, 230);
    text-align: center;
    font-size: 13px;
    color: rgb(117, 117, 117);
    margin-right: 5px;
    border-radius: 30px;
  }
  & li:nth-child(1){
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 25%;
  }
  & li:nth-child(2){
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 25%;
  }
  & li:nth-child(3){
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 50%;
  }
}
.orderItemsTrigger{
  font-size: 13px;
  display: inline-block;
  margin-top: 20px;
}
.cancelledStatus{
  font-size: 20px;
  float: right;
}
</style>
